<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>iiko Заказы</strong>
                </CCardHeader>
                <CCardBody>
                    <!-- Вкладки режимов -->
                    <ul class="nav nav-tabs mb-3">
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                :class="{ active: activeTab === 'date' }"
                                href="#"
                                @click.prevent="activeTab = 'date'"
                            >По дате</a>
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                :class="{ active: activeTab === 'search' }"
                                href="#"
                                @click.prevent="activeTab = 'search'"
                            >Поиск</a>
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                :class="{ active: activeTab === 'history' }"
                                href="#"
                                @click.prevent="activeTab = 'history'"
                            >История клиента</a>
                        </li>
                    </ul>

                    <!-- Вкладка: По дате -->
                    <CForm v-if="activeTab === 'date'">
                        <CRow>
                            <CCol cols="12" md="3">
                                <div class="form-group">
                                    <label>Дата от</label>
                                    <input
                                        type="datetime-local"
                                        class="form-control"
                                        v-model="filters.date_from"
                                    />
                                </div>
                            </CCol>
                            <CCol cols="12" md="3">
                                <div class="form-group">
                                    <label>Дата до</label>
                                    <input
                                        type="datetime-local"
                                        class="form-control"
                                        v-model="filters.date_to"
                                    />
                                </div>
                            </CCol>
                            <CCol cols="12" md="3">
                                <CSelect
                                    label="Партнёр"
                                    :value.sync="filters.partner_alias"
                                    :options="partnerOptions"
                                />
                            </CCol>
                            <CCol cols="12" md="3">
                                <CSelect
                                    label="Статус"
                                    :value.sync="filters.status"
                                    :options="statusOptions"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="mb-3">
                            <CCol>
                                <CButton color="primary" class="mr-2" :disabled="loading" @click="fetchOrders">
                                    <CIcon name="cil-magnifying-glass" class="mr-1" />Найти
                                </CButton>
                                <CButton color="secondary" variant="outline" :disabled="loading" @click="resetDateFilters">
                                    Сбросить
                                </CButton>
                            </CCol>
                        </CRow>
                    </CForm>

                    <!-- Вкладка: Поиск -->
                    <CForm v-if="activeTab === 'search'">
                        <CRow>
                            <CCol cols="12" md="4">
                                <div class="form-group">
                                    <label>Поиск (имя, телефон, номер заказа)</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="searchFilters.query"
                                        placeholder="Введите запрос..."
                                        @keydown.enter.prevent="fetchSearch"
                                    />
                                </div>
                            </CCol>
                            <CCol cols="12" md="2">
                                <div class="form-group">
                                    <label>Дата от</label>
                                    <input
                                        type="datetime-local"
                                        class="form-control"
                                        v-model="searchFilters.date_from"
                                    />
                                </div>
                            </CCol>
                            <CCol cols="12" md="2">
                                <div class="form-group">
                                    <label>Дата до</label>
                                    <input
                                        type="datetime-local"
                                        class="form-control"
                                        v-model="searchFilters.date_to"
                                    />
                                </div>
                            </CCol>
                            <CCol cols="12" md="2">
                                <CSelect
                                    label="Партнёр"
                                    :value.sync="searchFilters.partner_alias"
                                    :options="partnerOptions"
                                />
                            </CCol>
                            <CCol cols="12" md="2">
                                <div class="form-group">
                                    <label>Макс. результатов</label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model.number="searchFilters.rows"
                                        min="1"
                                        max="200"
                                    />
                                </div>
                            </CCol>
                        </CRow>
                        <CRow class="mb-3">
                            <CCol>
                                <CButton color="primary" class="mr-2" :disabled="loading" @click="fetchSearch">
                                    <CIcon name="cil-magnifying-glass" class="mr-1" />Найти
                                </CButton>
                                <CButton color="secondary" variant="outline" :disabled="loading" @click="resetSearchFilters">
                                    Сбросить
                                </CButton>
                            </CCol>
                        </CRow>
                    </CForm>

                    <!-- Вкладка: История клиента -->
                    <CForm v-if="activeTab === 'history'">
                        <CRow>
                            <CCol cols="12" md="3">
                                <div class="form-group">
                                    <label>Телефон клиента</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="historyFilters.phone"
                                        placeholder="+79001234567"
                                        @keydown.enter.prevent="fetchHistory"
                                    />
                                </div>
                            </CCol>
                            <CCol cols="12" md="3">
                                <div class="form-group">
                                    <label>Дата от</label>
                                    <input
                                        type="datetime-local"
                                        class="form-control"
                                        v-model="historyFilters.date_from"
                                    />
                                </div>
                            </CCol>
                            <CCol cols="12" md="3">
                                <div class="form-group">
                                    <label>Дата до</label>
                                    <input
                                        type="datetime-local"
                                        class="form-control"
                                        v-model="historyFilters.date_to"
                                    />
                                </div>
                            </CCol>
                            <CCol cols="12" md="3">
                                <CSelect
                                    label="Партнёр"
                                    :value.sync="historyFilters.partner_alias"
                                    :options="partnerOptions"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="mb-3">
                            <CCol>
                                <CButton color="primary" class="mr-2" :disabled="loading" @click="fetchHistory">
                                    <CIcon name="cil-magnifying-glass" class="mr-1" />Найти историю
                                </CButton>
                                <CButton color="secondary" variant="outline" :disabled="loading" @click="resetHistoryFilters">
                                    Сбросить
                                </CButton>
                            </CCol>
                            <CCol class="text-muted small d-flex align-items-center">
                                История доступна за последние 90 дней
                            </CCol>
                        </CRow>
                    </CForm>

                    <!-- Итог -->
                    <div v-if="!loading && orders.length > 0" class="mb-2 text-muted small">
                        Найдено заказов: <strong>{{ orders.length }}</strong>
                    </div>

                    <!-- Таблица заказов -->
                    <CDataTable
                        :items="orders"
                        :fields="fields"
                        :items-per-page="25"
                        items-per-page-select
                        pagination
                        sorter
                        hover
                        striped
                        :loading="loading"
                    >
                        <template #_partner_name="{ item }">
                            <td>
                                <CBadge color="info">{{ item._partner_name }}</CBadge>
                            </td>
                        </template>

                        <template #number="{ item }">
                            <td>
                                <span v-if="item.number">#{{ item.number }}</span>
                                <span v-else-if="item.externalNumber" class="text-muted small">{{ item.externalNumber }}</span>
                                <span v-else class="text-muted">—</span>
                            </td>
                        </template>

                        <template #status="{ item }">
                            <td>
                                <CBadge :color="statusColor(item.status)">
                                    {{ statusLabel(item.status) }}
                                </CBadge>
                            </td>
                        </template>

                        <template #customer="{ item }">
                            <td>
                                <div v-if="item.customer && item.customer.name">
                                    {{ item.customer.name }}
                                </div>
                                <div v-if="item.phone" class="text-muted small">{{ item.phone }}</div>
                                <span v-if="!item.customer && !item.phone" class="text-muted">—</span>
                            </td>
                        </template>

                        <template #sum="{ item }">
                            <td class="text-right">
                                <strong v-if="item.sum">{{ item.sum }} ₽</strong>
                                <span v-else class="text-muted">—</span>
                            </td>
                        </template>

                        <template #items="{ item }">
                            <td>
                                <span v-if="item.items && item.items.length">
                                    {{ item.items.length }} поз.
                                </span>
                                <span v-else class="text-muted">—</span>
                            </td>
                        </template>

                        <template #whenCreated="{ item }">
                            <td class="text-nowrap">{{ formatDate(item.whenCreated) }}</td>
                        </template>

                        <template #actions="{ item }">
                            <td>
                                <CButton
                                    color="info"
                                    variant="outline"
                                    size="sm"
                                    @click="openOrder(item)"
                                >
                                    <CIcon name="cil-zoom-in" />
                                </CButton>
                            </td>
                        </template>
                    </CDataTable>

                    <div v-if="!loading && orders.length === 0" class="text-center text-muted py-4">
                        Заказы не найдены. Укажите параметры и нажмите «Найти».
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import moment from 'moment'

const IIKO_STATUSES = {
    WaitCooking: 'Ожидает готовки',
    ReadyForCooking: 'Готово к готовке',
    CookingStarted: 'Готовится',
    CookingCompleted: 'Приготовлен',
    Waiting: 'Ожидает',
    OnWay: 'В пути',
    Delivered: 'Доставлен',
    Closed: 'Закрыт',
    Cancelled: 'Отменён',
    Unconfirmed: 'Не подтверждён',
    New: 'Новый',
}

const STATUS_COLORS = {
    WaitCooking: 'warning',
    ReadyForCooking: 'warning',
    CookingStarted: 'primary',
    CookingCompleted: 'info',
    Waiting: 'secondary',
    OnWay: 'primary',
    Delivered: 'success',
    Closed: 'dark',
    Cancelled: 'danger',
    Unconfirmed: 'secondary',
    New: 'info',
}

export default {
    name: 'IikoOrdersList',
    data() {
        return {
            activeTab: 'date',
            loading: false,
            orders: [],
            partners: [],
            filters: {
                date_from: moment().startOf('day').format('YYYY-MM-DDTHH:mm'),
                date_to: moment().endOf('day').format('YYYY-MM-DDTHH:mm'),
                partner_alias: '',
                status: ''
            },
            searchFilters: {
                query: '',
                date_from: moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DDTHH:mm'),
                date_to: moment().format('YYYY-MM-DDTHH:mm'),
                partner_alias: '',
                rows: 50
            },
            historyFilters: {
                phone: '',
                date_from: moment().subtract(90, 'days').startOf('day').format('YYYY-MM-DDTHH:mm'),
                date_to: moment().format('YYYY-MM-DDTHH:mm'),
                partner_alias: ''
            },
            fields: [
                { key: '_partner_name', label: 'Партнёр', sortable: true },
                { key: 'number', label: '№ заказа', sortable: true },
                { key: 'status', label: 'Статус', sortable: true },
                { key: 'customer', label: 'Клиент', sorter: false },
                { key: 'items', label: 'Позиции', sorter: false },
                { key: 'sum', label: 'Сумма', sortable: true },
                { key: 'whenCreated', label: 'Создан', sortable: true },
                { key: 'actions', label: '', _style: 'width:50px;', sorter: false, filter: false }
            ]
        }
    },
    computed: {
        partnerOptions() {
            return [
                { value: '', label: 'Все партнёры' },
                ...this.partners.map(p => ({ value: p.alias, label: p.name }))
            ]
        },
        statusOptions() {
            return [
                { value: '', label: 'Все статусы' },
                ...Object.entries(IIKO_STATUSES).map(([value, label]) => ({ value, label }))
            ]
        }
    },
    async mounted() {
        await this.fetchPartners()
    },
    methods: {
        async fetchPartners() {
            try {
                const { data } = await this.$http.get('/iiko-orders/partners')
                this.partners = data
            } catch (e) {
                console.error(e)
            }
        },
        async fetchOrders() {
            this.loading = true
            this.orders = []
            try {
                const params = {}
                if (this.filters.date_from) params.date_from = this.filters.date_from
                if (this.filters.date_to) params.date_to = this.filters.date_to
                if (this.filters.partner_alias) params.partner_alias = this.filters.partner_alias
                if (this.filters.status) params.statuses = this.filters.status

                const { data } = await this.$http.get('/iiko-orders', { params })
                this.orders = data.orders || []
            } catch (e) {
                this.$root.$emit('showError', 'Ошибка загрузки заказов iiko')
                console.error(e)
            }
            this.loading = false
        },
        async fetchSearch() {
            if (!this.searchFilters.query && !this.searchFilters.date_from) {
                this.$root.$emit('showError', 'Введите запрос или укажите дату')
                return
            }
            this.loading = true
            this.orders = []
            try {
                const params = {}
                if (this.searchFilters.query) params.query = this.searchFilters.query
                if (this.searchFilters.date_from) params.date_from = this.searchFilters.date_from
                if (this.searchFilters.date_to) params.date_to = this.searchFilters.date_to
                if (this.searchFilters.partner_alias) params.partner_alias = this.searchFilters.partner_alias
                if (this.searchFilters.rows) params.rows = this.searchFilters.rows

                const { data } = await this.$http.get('/iiko-orders/search', { params })
                this.orders = data.orders || []
            } catch (e) {
                this.$root.$emit('showError', 'Ошибка поиска заказов iiko')
                console.error(e)
            }
            this.loading = false
        },
        async fetchHistory() {
            if (!this.historyFilters.phone) {
                this.$root.$emit('showError', 'Введите номер телефона')
                return
            }
            this.loading = true
            this.orders = []
            try {
                const params = { phone: this.historyFilters.phone }
                if (this.historyFilters.date_from) params.date_from = this.historyFilters.date_from
                if (this.historyFilters.date_to) params.date_to = this.historyFilters.date_to
                if (this.historyFilters.partner_alias) params.partner_alias = this.historyFilters.partner_alias

                const { data } = await this.$http.get('/iiko-orders/history', { params })
                this.orders = data.orders || []
            } catch (e) {
                this.$root.$emit('showError', 'Ошибка загрузки истории клиента')
                console.error(e)
            }
            this.loading = false
        },
        resetDateFilters() {
            this.filters = {
                date_from: moment().startOf('day').format('YYYY-MM-DDTHH:mm'),
                date_to: moment().endOf('day').format('YYYY-MM-DDTHH:mm'),
                partner_alias: '',
                status: ''
            }
            this.orders = []
        },
        resetSearchFilters() {
            this.searchFilters = {
                query: '',
                date_from: moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DDTHH:mm'),
                date_to: moment().format('YYYY-MM-DDTHH:mm'),
                partner_alias: '',
                rows: 50
            }
            this.orders = []
        },
        resetHistoryFilters() {
            this.historyFilters = {
                phone: '',
                date_from: moment().subtract(90, 'days').startOf('day').format('YYYY-MM-DDTHH:mm'),
                date_to: moment().format('YYYY-MM-DDTHH:mm'),
                partner_alias: ''
            }
            this.orders = []
        },
        openOrder(order) {
            this.$router.push(`/iiko-orders/${order._partner_alias}/${order.id}`)
        },
        statusLabel(status) {
            return IIKO_STATUSES[status] || status || '—'
        },
        statusColor(status) {
            return STATUS_COLORS[status] || 'secondary'
        },
        formatDate(date) {
            if (!date) return '—'
            return moment(date).format('DD.MM.YYYY HH:mm')
        }
    }
}
</script>
